import React from 'react';
import { APPROVABLE, IGNORABLE } from './paymentUtils';

export const PaymentRowActions = ({ payment, onApprove, onIgnore, onUnignore }) => {
  const id = payment.mercury_txn_id;
  const s = payment.match_status;
  return (
    <div className="flex flex-wrap gap-3 text-xs">
      {APPROVABLE.includes(s) && (
        <button type="button" data-testid={`payment-approve-${id}`} onClick={() => onApprove(payment)}
          className="text-green-700 hover:underline font-medium">Approve</button>
      )}
      {IGNORABLE.includes(s) && (
        <button type="button" data-testid={`payment-ignore-${id}`} onClick={() => onIgnore(payment)}
          className="text-slate-600 hover:underline">Ignore</button>
      )}
      {s === 'ignored' && (
        <button type="button" data-testid={`payment-unignore-${id}`} onClick={() => onUnignore(payment)}
          className="text-blue-600 hover:underline">Un-ignore</button>
      )}
    </div>
  );
};
